<template>
  <div class="thumb-slide">
    <div class="card-carousel">
      <div class="card-img">

        <div v-if="activeImage === 0 && videoData">
          <div v-if="videoData.type === 'youtube'">
            <iframe
              ref="activeMedia"
              :class="
                `video-full img-fluid animated ${classe} img-atual-thumbSlide`
              "
              :src="videoData.embedUrl"
              allowfullscreen
              allow="autoplay"
            ></iframe>
          </div>
          <div v-if="videoData.type === 'vimeo'">
            <iframe
              ref="activeMedia"
              :class="
                `video-full img-fluid animated ${classe} img-atual-thumbSlide`
              "
              :src="videoData.embedUrl"
              allowfullscreen
              allow="autoplay"
            ></iframe>
          </div>
        </div>

        <div v-else>
          <img
            ref="activeMedia"
            v-viewer="{
              toolbar: false,
              navbar: false,
              minZoomRatio: 1,
              movable: false
            }"
            @click="stop_autoplay = true"
            class="img-zoom-in"
            :class="`img-fluid animated ${classe} img-atual-thumbSlide`"
            :src="currentImage"
            alt=""
          />
        </div>

        <div class="actions">
          <span @click="prevImage" class="prev">
            <i class="fa fa-chevron-left"></i>
          </span>
          <span @click="nextImage" class="next">
            <i class="fa fa-chevron-right"></i>
          </span>
        </div>

        <div v-for="(vistoria, id) in vistorias" :key="id" class="vistoria">
          <div v-if="vistoria.imovel_id > 0">
            <span v-if="vistoria.i_bn_ocupado == 'Desocupado'">
              <div style="display: none;">{{ (exibe_desocupado = true) }}</div>
            </span>
            <span v-else>
              <div style="display: none;">{{ (exibe_desocupado = false) }}</div>
            </span>
            <span v-if="vistoria.i_bn_permitevisitacao == true">
              <div style="display: none;">
                {{ (bn_permitevisitacao = true) }}
              </div>
            </span>
            <span v-else>
              <div style="display: none;">
                {{ (bn_permitevisitacao = false) }}
              </div>
            </span>
          </div>
          <div v-else>
            <div style="display: none;">{{ (exibe_desocupado = false) }}</div>
          </div>

        </div>

        <div v-if="exibe_desocupado == true">
        </div>
      </div>

      <carousel
        :perPageCustom="[
          [450, 2],
          [568, 3],
          [1024, 5]
        ]"
        :navigationEnabled="true"
        :paginationEnabled="false"
        :autoplay="false"
      >
        <slide
          v-for="(image, index) in carouselSlides"
          :key="image.id"
          :class="['thumbnail-image', activeImage == index ? 'active' : '']"
        >
          <img :src="image.thumb" @click="setImagemAtiva(index)"/>
        </slide>
      </carousel>
    </div>
  </div>
</template>
<script>
import Carousel from "@/components/customCarousel/Carousel";
import Slide from "@/components/customCarousel/Slide";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";

Vue.use(Viewer);

export default {
  components: {
    Carousel,
    Slide
  },
  props: ["images", "vistorias"],
  data() {
    return {
      activeImage: 0,
      classe: "",
      moreThan: false,
      thumbs: [],
      pos: 0,
      exibe_desocupado: false,
      bn_permitevisitacao: false,
      img_padra_video: "https://906de634c48fb7d34136160b4c353ae4.s3.amazonaws.com/public/core/galeria-play.jpg",
      stop_autoplay: false,
      autoplayInterval: null
    };
  },
  mounted() {
    this.loadAutoPlay();
    this.stop_autoplay = false;
  },
  watch: {
    vistorias: function (v) {
      // O 'computed' vai cuidar disso automaticamente
    }
  },
  computed: {
    carouselSlides() {
      const slides = [...this.images];

      if (this.isVideo) {
        slides.unshift({
          id: 'video-thumb',
          thumb: this.img_padra_video
        });
      }
      return slides;
    },
    currentImage() {
      if (!this.isVideo) {
        if (!this.images[this.activeImage]) return "";
        return this.images[this.activeImage].big;
      }

      if (this.activeImage > 0) {
        if (!this.images[this.activeImage - 1]) return "";
        return this.images[this.activeImage - 1].big;
      }

      return ''; // Retorno padrão para o índice 0 (vídeo)
    },
    isVideo() {
      if (!this.vistorias || !Array.isArray(this.vistorias)) return false;
      return this.vistorias.some(
        vi => vi.v_nm_youtube || vi.e_nm_youtube || vi.i_nm_youtube
      );
    },
    videoData() {
      if (!this.vistorias || !Array.isArray(this.vistorias)) {
        return null;
      }
      const vistoriaComVideo = this.vistorias.find(
        v => v.v_nm_youtube || v.e_nm_youtube || v.i_nm_youtube
      );
      if (!vistoriaComVideo) {
        return null;
      }
      const rawLink = vistoriaComVideo.v_nm_youtube || vistoriaComVideo.e_nm_youtube || vistoriaComVideo.i_nm_youtube;
      return this.formataLinkVideo(rawLink);
    }
  },
  methods: {
    nextImage() {
      this.stop_autoplay = true;
      var active = this.activeImage + 1;
      if (active >= this.carouselSlides.length) {
        active = 0;
      }
      this.activateImage(active);
    },
    prevImage() {
      this.stop_autoplay = true;
      var active = this.activeImage - 1;
      if (active < 0) {
        active = this.carouselSlides.length - 1;
      }
      this.activateImage(active);
    },
    setImagemAtiva(imageIndex) {
      this.stop_autoplay = true;
      this.activateImage(imageIndex);
    },
    activateImage(imageIndex) {
      this.activeImage = imageIndex;
      if (!this.videoData) {
        this.classe = "";
      }

      const limpaClass = () => {
        this.classe = "";
      };

      const element = this.$refs.activeMedia;

      if (element) {
        element.addEventListener('webkitAnimationEnd', limpaClass, { once: true })
        element.addEventListener('oAnimationEnd', limpaClass, { once: true })
        element.addEventListener('msAnimationEnd', limpaClass, { once: true })
        element.addEventListener('animationend', limpaClass, { once: true })
      }
    },
    loadAutoPlay() {
      var self = this;

      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval)
      }

      this.autoplayInterval = setInterval(() => {
        if (this.stop_autoplay == false) {
          //console.log('muda');
          var active = self.activeImage + 1;
          if (active >= self.images.length) {
            active = 0;
          }
          self.activateImage(active);
        }
      }, 15000);
    },
    formataLinkVideo(link) {
      if (!link) return null;

      try {
        const youtubeRegex = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
        const youtubeMatches = link.match(youtubeRegex);

        if (youtubeMatches && youtubeMatches[1]) {
          return {
            type: 'youtube',
            embedUrl: `https://www.youtube.com/embed/${youtubeMatches[1]}?autoplay=1`
          };
        }

        const vimeoRegex = /\/\/(?:www\.|player\.)?vimeo.com\/(?:video\/)?([0-9]+)/;
        const vimeoMatches = link.match(vimeoRegex);

        if (vimeoMatches && vimeoMatches[1]) {
          return {
            type: 'vimeo',
            embedUrl: `https://player.vimeo.com/video/${vimeoMatches[1]}?autoplay=1`
          };
        }
      } catch (e) {
        console.error("Erro ao formatar link de vídeo:", link, e);
      }

      return null;
    }
  },
  beforeDestroy() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval)
      this.autoplayInterval = null
    }
  }
};
</script>
<style scoped>
.thumb-slide {
  overflow: hidden;
}

.card-carousel {
  user-select: none;
}

.img-fluid {
  width: 100%;
}

.thumbnail-image {
  margin-bottom: 10px;
  cursor: pointer;
}

.thumbnail-image.active > img {
  opacity: 0.6;
  box-shadow: 2px 2px 6px 1px rgba(0, 0, 0, 0.5);
}

.card-img {
  position: relative;
  margin-bottom: 15px;
}

.card-img > img {
  display: block;
  margin: 0 auto;
}

.desktop {
  display: block;
  /* ou inline, inline-block */
}

.mobile {
  display: none;
}

.video-full {
  width: 640px;
  height: 480px;
}

@media (max-width: 480px) {
  .desktop {
    display: none;
  }

  .mobile {
    display: block;
    /* ou inline, inline-block */
  }

  .video-full {
    width: 75vw;
    height: 30vh;
  }
}

.img-zoom-in {
  cursor: zoom-in;
}

.imovel_desocupado {
  font-size: 20px;
  background-color: #ffbc0c;
  float: right;
  margin-right: 5px;
  margin-top: -50px;
  color: #68302b;
  width: 55%;
  height: 63px;
  padding-top: 5px;
  padding-bottom: 5px;
  transform: translateY(-70%);
}

.texto_agenda {
  font-size: 14px;
  color: black;
}

.actions {
  font-size: 1.5em;
  height: 40px;
  position: absolute;
  top: 50%;
  margin-top: -20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #67302b;
}

.actions > span,
.prevnext-thumbs span {
  cursor: pointer;
  transition: all 250ms;
  background: #fff;
  padding: 10px;
  border-radius: 3px;
}

.actions > span.prev {
  margin-left: -2px;
}

.actions > span.next {
  margin-right: -2px;
}

.actions > span:hover {
  color: #151515;
}
</style>
<style>
.VueCarousel-wrapper {
  position: relative;
  z-index: 10;
}

.VueCarousel-navigation a {
  text-decoration: none !important;
}

.VueCarousel-navigation a.VueCarousel-navigation-prev {
  left: 24px !important;
  background: #fff;
  border-radius: 2px;
  z-index: 20;
}

.VueCarousel-navigation a.VueCarousel-navigation-next {
  right: 24px !important;
  border-radius: 2px;
  background: #fff;
  z-index: 20;
}
</style>



// WEBPACK FOOTER //
// src/components/thumbSlide/ThumbSlide.vue